import { z } from 'zod'
import { CategoryType } from '../../enums/category-type.enum'
import { IncomeType } from '../../enums/income-type.enum'

export const categoryResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  type: z.nativeEnum(CategoryType),
  description: z.string().nullable(),
  color: z.string().nullable(),
  incomeType: z.nativeEnum(IncomeType).nullable(),
  isDefault: z.boolean(),
  isSystem: z.boolean(),
  order: z.number().int(),
  userId: z.string().guid().nullable(),
  groupId: z.string().guid().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CategoryResponseDto = z.infer<typeof categoryResponseSchema>
